<template>
  <transition name="slide-fade">
    <div class="drawer" v-show="showDrawer">
      <el-row class="drawer-header" type="flex" align="middle">
        <el-col class="header-title">
          <div class="main-title">{{ mainTitle }}</div>
          <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
        </el-col>
        <el-col class="header-btn">
          <span class="btn" @click="closeDrawer">
            <i class="btn-icon fa fa-close"></i>
          </span>
        </el-col>
      </el-row>
      <div class="drawer-content">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Drawer',
  data() {
    return {};
  },
  props: ['showDrawer', 'mainTitle', 'subTitle'],
  methods: {
    closeDrawer() {
      this.$emit('update:showDrawer', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  // height: calc(100vh - 60px);
  min-height: 100vh;
  width: 45%;
  min-width: 480px;
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  .drawer-header {
    padding: 20px 16px;
    border-bottom: 1px solid #ebeef5;
  }
  .drawer-content {
    padding: 30px 20px;
    color: #606266;
    line-height: 24px;
    font-size: 14px;
    overflow: auto;
  }
  .header-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .main-title {
      font-size: 18px;
      color: #303133;
    }
    .sub-title {
      font-size: 14px;
      color: #85878c;
    }
  }
  .header-btn {
    flex-basis: 40px;
    .btn {
      margin: 0 6px;
      padding: 8px;
      cursor: pointer;
      .btn-icon {
        font-size: 24px;
        font-weight: 400;
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  // transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transition: all .2s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  // transform: translateX(45%);
  transform: translateX(20%);
  // opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/v-drawer.vue